export const API_NAME = "guides";
export const ROUTE_NAME = "guides";
export const COMPONENT_NAMES = ["guides", "guides"];
